module.exports = __webpack_public_path__ + "static/media/large_tool_gauge.8498e738.png";